export const getActiveAccountCategories = (account, categories) =>
  categories
    .filter((category) => category.active && category.account_id === account.id)
    .sort((a, b) => a.name.localeCompare(b.name));
